
  const styleMainBox1 = {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    cursor: 'pointer', 
    p: 1, 
    borderRadius: '4px'
  };
  const styleMainBox2 = {
    placeItems: "center", 
    paddingBottom:'20px', 
    borderBottom:'1px lightgray solid' 
  };
  
  const styleTableCell = { 
    padding: '4px',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    verticalAlign: 'middle',
    color:'white'
  };
  
  const styleTableCell2 = { 
    padding: '4px',
    fontSize: '0.8rem',
    textAlign: 'center',
    verticalAlign: 'middle',
    color:'black'
  };

  const styleBoxLeft = { 
    width: 200, 
    bgcolor: "secondary.lateral", 
    p: 2, 
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '-2px 0 5px rgba(0,0,0,0.1)', 
    position: 'sticky', 
    top: 0,
  };

  const styleDocExplorer = { 
    width: '600px', 
    height: 'fit-content', 
    pt: 2, 
    border: '1px solid #ccc', 
    borderRadius: '8px',
    mt: 2, 
    bgcolor: '#e0e0e0', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center',
    boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
  };

  const styleImage = {
    width: 120,
    height: 50,
    marginRight: 1
  };

  export { 
    styleMainBox1, styleMainBox2, styleTableCell, styleTableCell2, 
    styleBoxLeft, styleDocExplorer, styleImage
  };